import { useState } from "react";
import { ParameterDataType } from "../types/Category";

type RangeMode = Record<string, boolean>;
type Filters = Record<string, string>;

type RangeChangeType = "min" | "max";

export function useParameterFilters() {
    const [filters, setFilters] = useState<Filters>({});
    const [rangeMode, setRangeMode] = useState<RangeMode>({});

    const setFilter = (name: string, value: string) => {
        setFilters(prev => ({ ...prev, [name]: value }));
    };

    const setRangeValue = (name: string, type: RangeChangeType, value: string) => {
        setFilters(prev => ({
            ...prev,
            [`${name}_${type}`]: value,
        }));
    };

    const toggleRange = (name: string, use: boolean) => {
        setRangeMode(prev => ({ ...prev, [name]: use }));

        setFilters(prev => {
            const updated = { ...prev };
            delete updated[name];
            delete updated[`${name}_min`];
            delete updated[`${name}_max`];
            return updated;
        });
    };

    const resetFilters = () => {
        setFilters({});
        setRangeMode({});
    };

    return {
        filters,
        rangeMode,
        setFilter,
        setRangeValue,
        toggleRange,
        resetFilters,
    };
}